import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missing-tenant',
  templateUrl: './missing-tenant.component.html',
  styleUrls: ['./missing-tenant.component.sass']
})
export class MissingTenantComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
